<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        現場管理 - 一括登録
        <div class="headerBtn" @click="screenTransition(siteslistPath)" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <div class="group" v-if="!getLodingFlg && !getErrorFlg">
        <div class="groupTitle" style="display: flex;">
          登録準備
        </div>
        <div class="row" style="text-align: left;">
          最初に、以下のボタンより登録用のテンプレートファイルをダウンロードします。<br>
        </div>
        <div class="row">
          <div class="edit" @click="doDownload(templateFilePath, templateFileName)">
            <!--  DLアイコン設定予定 v-icon? -->
            テンプレート
          </div>
          <div class="detail" @click="doDownload(sumpleFilePath, sumpleFileName)">
            <!--  DLアイコン設定予定 v-icon? -->
            記入サンプル
          </div>
        </div>
      </div>

      <div class="group" v-if="!getLodingFlg && !getErrorFlg">
        <div class="groupTitle" style="display: flex;">
          登録用テンプレート記載方法
        </div>
        <div class="row" style="text-align: left;">
          2行目以降にCCUS現場ID、現場名、工期開始日、工期終了日、現場住所の郵便番号、都道府県、市区町村、<br>
          町・番地、建物名、現場管理者名、Face-DB Serverとの連携要否  をカンマ区切りで記載します。<br>
          電話番号は現場管理者のものが自動で入力されます。<br>
          Face-DB Serverとの連携要否は連携対象は「1」、連携非対象「0」と入力ください。それ以外の値はエラーとなります。<br>
          空白や空行を含めますと正常に処理が終了しない可能性がございますので、加えないようお願い致します。<br>
          行の末尾にはカンマは不要です。<br>
          Excelなどで保存した場合、エラーとなる可能性がございますので、編集時には他のテキストツールをご利用下さい。
        </div>
        <div class="row">
          <img src="../assets/site-bulk-sample.png">
        </div>
      </div>

      <div class="group" v-if="!getLodingFlg && !getErrorFlg">
        <div class="groupTitle" style="display: flex;">
          <!--  アップロードアイコン設定予定 v-icon? -->
          アップロード
        </div>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="row">
            <p class="inputTitle editable">事業者</p>
            <validation-provider name="事業者" rules="required">
              <div class="rowRight" slot-scope="ProviderProps">
                <div class="company-multiselect">
                  <multiselect
                    v-model="selectedCompany"
                    :options="optionCompanies"
                    :multiple="false"
                    :taggable="false"
                    label="companyName"
                    placeholder="事業者を選択"
                    selectLabel="選択"
                    deselectLabel="解除"
                    selectedLabel="選択済"
                    track-by="companyId"
                    @input="callGetBranchsNameList($event ? $event.companyId : null)"
                  >
                    <span slot="noOptions"></span>
                  </multiselect>
                </div>
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>
        <div class="row">
          <p class="inputTitle editable">支店</p>
          <validation-provider name="支店" rules="required">
            <div class="rowRight" slot-scope="ProviderProps">
              <div class="selectdiv">
                <select  v-model="selectBranches">
                  <option value="" selected>支店を選択</option>
                  <option v-for="branch in optionBranches"
                    v-bind:value="branch.branchId">
                    {{ branch.branchName }}
                  </option>
                </select>
              </div>
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
        </validation-provider>
      </div>
          <div class="row" style="text-align: left;">
            現場情報を記載し保存したファイルを以下で選択し、アップロードして下さい。
          </div>
          <div class="row">
            <div style="text-align: left">
            <validation-provider name="対象のファイル" rules="required|ext:csv">
              <div slot-scope="ProviderProps">
                <input　class="file" type="file" ref="uploadFile" accept=".csv" @change="ProviderProps.validate($event); loadCsvFile($event)">
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>
        </div>
          <div class="row" style="text-align: left;">
            選択されたファイル: {{fileName}} <br>
            対応するファイル形式　.csv/最大件数1000件
          </div>
          <div class="buttonGroup">
            <button class="btn" @click="csvExtract"
            v-bind:class="{
              disabled: ObserverProps.invalid || !ObserverProps.validate || !upFile || parseFlg,
              active: !ObserverProps.invalid && ObserverProps.validate && upFile && !parseFlg
            }"
            :disabled="ObserverProps.invalid || parseFlg || postLodingFlg"
            style="width: 400px;">アップロードして確認
            </button>
          </div>
        </validation-observer>
      </div>

      <!-- ローディング -->
      <div v-if="postLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>

      <!-- 登録エラー表示 -->
      <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの登録中に問題が発生しました。
          </div>
        </div>
      </div>

      <div v-if="rows.length > 0 && !postLodingFlg">
        <vue-good-table
          :columns='columns'
          :rows='rows'
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdownEnabled: false,
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: '次へ',
            prevLabel: '前へ',
            rowsPerPageLabel: '表示する行数',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All',
          }"
          :group-options="{
            enabled: false
          }"
          >
          <div slot="emptystate">データがありません</div>
        </vue-good-table>
        <div class="buttonGroup">
          <button class="btn" @click="confirm" style="width: 400px;"
          v-bind:class="{active: true}">
            登録
          </button>
        </div>
      </div>
      <div v-if="errorMessages.length > 0">
        <div　class="errMsg" v-for="error in errorMessages">
          <div class="errSpan">{{error}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { validate, ValidationProvider, ValidationObserver } from 'vee-validate';
import { VueGoodTable } from 'vue-good-table';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';
import constants from "../constants/constants";

export default {
  title: '現場一括登録',
  name: 'SiteAdd',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueGoodTable,
    VueLoading,
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      // 現場一覧パス
      siteslistPath: '/sites',
      // テンプレートファイルパス
      templateFilePath: '/files/site-bulk-template.csv',
      // テンプレートファイルダウンロード時のファイル名
      templateFileName: 'site-bulk-template.csv',
      // 記入サンプルファイルパス
      sumpleFilePath: '/files/site-bulk-sample.csv',
      // 記入サンプルファイルダウンロード時のファイル名
      sumpleFileName: 'site-bulk-sample.csv',
      // アップロードファイル
      fileName: '',
      upFile: '',
      csvData: {},
      // 選択した事業者用
      selectedCompanies: '',
      // 選択した支店用
      selectBranches: '',
      // 選択用事業者配列　事業者一覧取得APIが実装され次第そちらに変更
      optionCompanies: [],
      // 選択用支店配列
      optionBranches: [],
      errorMessages: [],
      columns:  [
        {
          label: 'CCUS現場ID',
          field: 'ccusId',
          width: '90px',
        },
        {
          label: '事業者ID',
          field: 'companyId',
          width: '125px',
          // TODO suzuno formatFn: を置き、IDに一致する事業者名を取得予定
        },
        {
          label: '支店ID',
          field: 'branchId',
          width: '125px',
          // TODO suzuno formatFn: を置き、IDに一致する支店名を取得予定
        },
        {
          label: '現場名',
          field: 'siteName',
          width: '100px',
          // TODO suzuno formatFn: を置き、IDに一致する現場名を取得予定
        },
        {
          label: '工期（開始）',
          field: 'startDate',
          width: '125px',
        },
        {
          label: '工期（終了）',
          field: 'endDate',
          width: '125px',
        },
        {
          label: '郵便番号',
          field: 'postalCode',
          width: '125px',
        },
        {
          label: '都道府県',
          field: 'prefecture',
          width: '125px',
        },
        {
          label: '市区町村',
          field: 'city',
          width: '125px',
        },
        {
          label: '町・番地',
          field: 'town',
          width: '125px',
        },
        {
          label: '建物名/部屋番号',
          field: 'otherAddress',
          width: '125px',
        },
        {
          label: '現場管理者ID',
          field: 'supervisorId',
          width: '100px',
        },
        {
          label: '電話番号',
          field: 'tel',
          width: '100px',
        },
        {
          label: 'Face-DB Serverとの連携対象とする',
          field: 'syncFlg',
          width: '180px',
          formatFn: (value) => value === 1 || value === '1' ? 'ON' : 'OFF',
        },
        {
          label: '自動承認',
          field: 'approve',
          hidden: true,
        },
      ],
      rows: [],
      workers: [],
      // ローディング
      getLodingFlg: false,  // データ取得時ローディング用フラグ
      getErrorFlg: false,   // データ取得時エラーフラグ
      postLodingFlg: false, // データ登録時ローディングフラグ
      postErrorFlg: false,  // データ登録時エラーフラグ
      parseFlg: false,
      errorMessage: '',
      searchCondition: {},
    };
  },
  // 初期処理
  async mounted() {
    try {
      // ローディング表示
      this.getLodingFlg = true;
      // 事業者リスト取得API呼出
      this.optionCompanies = await this.callGetCompaniesList();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 事業者リスト取得API呼び出し
    async callGetCompaniesList() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getCompaniesNameList();
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 支店名リスト取得API呼び出し
    async callGetBranchsNameList(companyId) {
      try {
        this.selectedCompanies = companyId;
        const restResourceService = new ApiClient();
        this.optionBranches = await restResourceService.getBranchesNameList(companyId);
        return  this.optionBranches;
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
    // アップロードファイル取得
    loadCsvFile(event) {
      this.fileName = event.target.files[0].name;
      this.upFile = event.target.files[0];
      this.$refs.uploadFile.value = null;
      this.parseFlg = false;
    },
    // アップロードして確認ボタン押下時
    async csvExtract() {
      this.postLodingFlg = true;
      const errorMessages = new Array();
      let flg = false;
      try {
        // 抽出CSV配列とエラーメッセージ配列を空にする
        this.csvData.length = 0;
        if (!this.upFile) {
          errorMessages.push('ファイルを選択して下さい。');
          return;
        }
        // 取り込んだCSVファイルをオブジェクト配列に変換
        this.$papa.parse(this.upFile, {
          encoding: 'Shift-JIS',
          header: true,
          complete: this.csvGet,
          error: function(err, file) {
            errorMessages.push('CSVの抽出に失敗しました。ファイルを再度選択して下さい');
            flg = true;
          }
        });
      } catch (error) {
        this.postLodingFlg = false;
        errorMessages.push('CSVの抽出に失敗しました。ファイル内のデータをご確認下さい');
      } finally {
        this.errorMessages = errorMessages;
        new Promise<void>((resolve) => {
          setTimeout(() => {
            resolve();
          }, 1);
        }).then(() => {
          this.parseFlg = flg;
          this.scrollBottom();
        });
      }
    },
    // CSVから抽出されたオブジェクト配列を加工
    async csvGet(results) {
      try {
        const errorMessages = new Array();
        // 事業者ID　completeの中では参照できないためローカルの変数に移す
        const selectedCompanies = this.selectedCompanies;
        const selectBranches = this.selectBranches;
        this.csvData = results.data;
        this.searchCondition['companyId'] = this.companyId;
        this.searchCondition['branchId'] = this.branchId;
        const restResourceService = new ApiClient();
        // TODO: 取得人数
        const result =await restResourceService.getWorkersList(constants.LIMIT, constants.PAGE, this.searchCondition,{})
        this.workers = result.workers;
        if (this.csvData.length === 0) {
          errorMessages.push('登録データが存在しません。ファイル内のデータをご確認下さい。');
        }
        for (let i = 0; i < this.csvData.length; i++) {
          // 選択した事業者の事業者IDをプロパティとして追加
          this.csvData[i].companyId = selectedCompanies;
          this.csvData[i].branchId = selectBranches;
          this.csvData[i].parentCompanyId = ''; // TODO 親会社IDを取得　選択欄追加
          this.csvData[i].rank = 1; // TODO 何次受けかを入力もしくは取得　方法不明
          this.csvData[i].fullAddress = this.csvData[i].prefecture + this.csvData[i].city + this.csvData[i].town;
          // 現場管理者確認
          if (this.csvData[i].supervisorId) {
            const supervisor = this.workers.find((v) => v.workerId === this.csvData[i].supervisorId);
            if (supervisor) {
              this.csvData[i].supervisorId = supervisor.workerId;
              this.csvData[i].tel = supervisor.tel;
            } else {
              errorMessages.push((i + 1) + '行目 現場管理者のID指定に誤りがあります。IDをご確認下さい。');
            }
          }
          this.csvData[i].approve = 1;
          // 必要情報が欠けた行が存在した場合、エラーメッセージを詰める
          if (!this.csvData[i].ccusId && !this.csvData[i].siteName &&
            !this.csvData[i].startDate && !this.csvData[i].endDate &&
            !this.csvData[i].prefecture && !this.csvData[i].city &&
            !this.csvData[i].town && !this.csvData[i].approve && 
            !this.csvData[i].syncFlg) {
            // errorMessages.push('必要な列情報がありません。フォーマットを確認して下さい。');
            // 空行の場合処理を終了する
            this.csvData.splice(i);
            break;
          }

          const ccusId = common.trimSpace(this.csvData[i].ccusId);
          await validate(ccusId, 'digits:14', {
            name: 'CCUS現場ID（ccusId）',
            values: {
              ccusId,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });
          //
          // if (!this.csvData[i].siteName) {
          //   errorMessages.push((i + 1) + '行目 現場名（siteName）が設定されていません。');
          // }
          const siteName = common.trimSpace(this.csvData[i].siteName);
          await validate(siteName, 'required', {
            name: '現場名（siteName）',
            values: {
              siteName,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          const startDate = common.trimSpace(this.csvData[i].startDate);
          await validate(startDate, 'required', {
            name: '工期開始日（startDate）',
            values: {
              startDate,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          const endDate = common.trimSpace(this.csvData[i].endDate);
          await validate(endDate, 'required|futureDay|periodValidityBulk:startDate', {
            name: '工期終了日（endDate）',
            values: {
              startDate,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          const postalCode = common.trimSpace(this.csvData[i].postalCode);
          await validate(postalCode, 'required|digits:7', {
            name: '郵便番号（postalCode）',
            values: {
              postalCode,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          const prefecture = common.trimSpace(this.csvData[i].prefecture);
          await validate(prefecture, 'required', {
            name: '都道府県（prefecture）',
            values: {
              postalCode,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          const city = common.trimSpace(this.csvData[i].city);
          await validate(city, 'required|max:128', {
            name: '市区町村（city）',
            values: {
              postalCode,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          const town = common.trimSpace(this.csvData[i].town);
          await validate(town, 'required|max:128', {
            name: '町・番地（town）',
            values: {
              town,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          const otherAddress = this.csvData[i].otherAddress;
          await validate(otherAddress, 'max:128', {
            name: '建物名/部屋番号（otherAddress）',
            values: {
              otherAddress,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });
          
          const syncFlg = common.trimSpace(this.csvData[i].syncFlg);
          await validate(syncFlg, 'required', {
            name: 'Face-DB Serverとの連携対象とする（syncFlg）',
            values: {
              syncFlg,
            },
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });
          if (syncFlg !== '0' && syncFlg !== '1') {
            errorMessages.push((i + 1) + '行目 Face-DB Serverとの連携対象とする（syncFlg）には0または1を入力してください。');
          } else {
            this.csvData[i].syncFlg = syncFlg === '1' ? 1 : 0;
            if (!ccusId || ccusId === '') {
              this.csvData[i].syncFlg = 0;
            }
          }

          this.csvData[i].approve = true;
        }
        // エラーメッセージが詰められていた場合、処理を中断する
        if (errorMessages.length !== 0) {
          this.errorMessages = errorMessages;
          this.scrollBottom();
          return;
        }
        this.rows = this.csvData;
        this.scrollBottom();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
      }
    },
    // DOM更新待機後スクロール
    async scrollBottom() {
      await this.$nextTick();
      common.scrollBottom();
    },
    // 登録ボタン押下時処理
    async confirm() {
      try {
        this.header =  false;
        this.postLodingFlg = true;
        this.postErrorFlg = false;
        for (let i = 0; i < this.csvData.length; i++) {
          this.csvData[i].startDate = common.unixTimeFormat(this.csvData[i].startDate);
          this.csvData[i].endDate = common.unixTimeFormat(this.csvData[i].endDate);
        }
        // 一括登録API呼出
        const restResourceService = new ApiClient();
        // 一括登録実行
        await restResourceService.postSite(this.csvData);
        this.screenTransition(this.siteslistPath);
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
        await this.$nextTick();
        common.scrollBottom();
      }
    },
    // ダウンロード処理（ファイルパス, DL時ファイル名）
    doDownload(url, filename) {
      common.doDownload(url, filename);
    },
    // 画面遷移
    screenTransition(path) {
      history.back();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";

/*** iOS ***/
.switch__label {
	width: 100px;
	position: relative;
	display: inline-block;
  margin-top: 13px;
}
.switch__content {
	display: block;
  cursor: pointer;
  position: relative;
  border-radius: 30px;
  height: 31px;
overflow: hidden;
}
.switch__content:before {
	content: "";
	display: block;
	position: absolute;
	width: calc(100% - 3px);
	height: calc(100% - 3px);
	top: 0;
	left: 0;
	border: 1.5px solid #E5E5EA;
	border-radius: 130px;
	background-color: #fff;
}
.switch__content:after {
	content: "";
	display: block;
	position: absolute;
	background-color: transparent;
	width: 0;
	height: 0;
	top: 50%;
	left: 50%;
	border-radius: 30px;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input {
	display: none;
}

.switch__circle {
	display: block;
	top: 2px;
	left: 2px;
	position: absolute;
	-webkit-box-shadow: 0 2px 6px #999;
	        box-shadow: 0 2px 6px #999;
	width: 27px;
	height: 27px;
	-webkit-border-radius: 20px;
	        border-radius: 20px;
	background-color: #fff;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input:checked ~ .switch__circle {
	left: 71px;
}

.switch__input:checked ~ .switch__content:after {
	background-color: #4BD964;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 14.5px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}

// multiselectの外枠
.company-multiselect {
  min-width: 494px !important;
  max-width: 494px !important;
}

// 閉じているときの入力枠
.company-multiselect ::v-deep .multiselect__tags {
  border: 2px solid #000 !important;
  border-radius: 10px !important;
  min-height: 45px !important;
  font-size: 14.5px !important;
}

// 選択後に表示される1行
.company-multiselect ::v-deep .multiselect__single {
  color: #333 !important;
  font-size: 14.5px !important;
}

// 未選択時のプレースホルダ
.company-multiselect ::v-deep .multiselect__placeholder {
  color: #333 !important;
  font-size: 14.5px !important;
}

// 開いたドロップダウン一覧の外枠
.company-multiselect ::v-deep .multiselect__content-wrapper {
  border: 2px solid #000 !important;
  border-top: none !important;
}

// 一覧でフォーカスが当たっている行
.company-multiselect ::v-deep .multiselect__option--highlight {
  background: #666 !important;
  color: #ffffff !important;
}

// 上記行の右側ラベル
.company-multiselect ::v-deep .multiselect__option--highlight::after {
  background: #666 !important;
  color: #ffffff !important;
}

// すでに選択済みとしてマークされた行
.company-multiselect ::v-deep .multiselect__option--selected {
  color: #333 !important;
  font-size: 14.5px !important;
}

// 選択済み行でかつフォーカスも重なったとき
.company-multiselect ::v-deep .multiselect__option--selected.multiselect__option--highlight {
  background: #666 !important;
  color: #e8e8e8 !important;
}

</style>
